import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VDialog, {
    style: {
      zIndex: _vm.options.zIndex
    },
    attrs: {
      persistent: "",
      "max-width": _vm.options.width
    },
    on: {
      keydown: function keydown($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) return null;
        return _vm.close(false);
      }
    },
    model: {
      value: _vm.shown,
      callback: function callback($$v) {
        _vm.shown = $$v;
      },
      expression: "shown"
    }
  }, [_c(VCard, [_c(VToolbar, {
    attrs: {
      color: _vm.options.color,
      dense: "",
      flat: ""
    }
  }, [_c(VToolbarTitle, {
    staticClass: "white--text"
  }, [_vm._v("Change departure warehouse")])], 1), _c(VCardText, {
    staticClass: "pt-5"
  }, [_c(VForm, {
    staticClass: "dfwa-form",
    model: {
      value: _vm.form.isValid,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "isValid", $$v);
      },
      expression: "form.isValid"
    }
  }, [_c(VAutocomplete, {
    attrs: {
      items: _vm.gettingAvailableWarehouses.results,
      "item-value": "id_warehouse",
      "item-text": "name",
      label: "New warehouse departure",
      "hide-details": "auto",
      required: "",
      rules: [_vm.formRules.mustSelectValue],
      filter: _vm.filterVAutocomplete
    },
    model: {
      value: _vm.form.warehouseId,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "warehouseId", $$v);
      },
      expression: "form.warehouseId"
    }
  }), _c("div", {
    staticClass: "mt-4"
  }, [_c(VSwitch, {
    staticClass: "v-text-field-no-label",
    attrs: {
      label: _vm.form.isCreateDomesticTransfer ? "Will automatically create an associated domestic stock transfer with items from current departure warehouse" : "Will NOT create automatically a domestic stock transfer",
      "hide-details": "auto"
    },
    model: {
      value: _vm.form.isCreateDomesticTransfer,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "isCreateDomesticTransfer", $$v);
      },
      expression: "form.isCreateDomesticTransfer"
    }
  }), _vm.form.isCreateDomesticTransfer ? _c(VSwitch, {
    staticClass: "v-text-field-no-label",
    attrs: {
      label: _vm.form.isImmediateDomesticTransfer ? "Will create an immediate transfer, like the products are already in the right warehouse" : "Will create a pending transfer, a reception validation will be required later",
      "hide-details": "auto"
    },
    model: {
      value: _vm.form.isImmediateDomesticTransfer,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "isImmediateDomesticTransfer", $$v);
      },
      expression: "form.isImmediateDomesticTransfer"
    }
  }) : _vm._e()], 1)], 1)], 1), _c(VCardActions, {
    staticClass: "card-actions"
  }, [_c(VBtn, {
    staticClass: "dfwa-btn --small secondary",
    attrs: {
      rounded: "",
      disabled: _vm.savingChange.isPending
    },
    nativeOn: {
      click: function click($event) {
        return _vm.close(false);
      }
    }
  }, [_c(VIcon, {
    staticClass: "fa fa-times mr-2",
    attrs: {
      size: "0.85rem"
    }
  }), _vm._v(" Cancel ")], 1), _c(VBtn, {
    staticClass: "dfwa-btn --small",
    attrs: {
      rounded: "",
      loading: _vm.savingChange.isPending,
      disabled: !_vm.form.isValid
    },
    nativeOn: {
      click: function click($event) {
        return _vm.save.apply(null, arguments);
      }
    }
  }, [_c(VIcon, {
    staticClass: "fa fa-save mr-2",
    attrs: {
      size: "0.85rem"
    }
  }), _vm._v(" Confirm ")], 1)], 1)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };